import { render, staticRenderFns } from "./S_Details.vue?vue&type=template&id=42259bcd&scoped=true"
import script from "./S_Details.vue?vue&type=script&lang=js"
export * from "./S_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42259bcd",
  null
  
)

export default component.exports